import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiFileText, FiImage, FiVideo, FiCalendar, FiSmartphone, FiYoutube } = FiIcons;

const ContentPlanning = ({ client, data }) => {
  const [activeTab, setActiveTab] = useState('blogs');
  const safeData = data || {
    blogPostsCount: 0,
    socialPostsCount: 0,
    upcomingBlogs: [],
    upcomingSocial: [],
    upcomingVideos: []
  };

  const tabs = [
    { id: 'blogs', label: 'Blog Posts', icon: FiFileText },
    { id: 'social', label: 'Social Posts', icon: FiImage },
    { id: 'videos', label: 'Videos', icon: FiVideo }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">Content Planning</h2>
        <p className="text-gray-600">Upcoming content schedule</p>
      </div>

      <div className="flex space-x-4 mb-4">
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 flex-1">
          <h3 className="text-gray-500 text-sm">Total Blogs</h3>
          <p className="text-2xl font-bold">{safeData.blogPostsCount}</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 flex-1">
          <h3 className="text-gray-500 text-sm">Total Social Posts</h3>
          <p className="text-2xl font-bold">{safeData.socialPostsCount}</p>
        </div>
      </div>

      <div className="flex border-b border-gray-200 mb-4">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 flex items-center space-x-2 ${
              activeTab === tab.id
                ? 'border-b-2 border-[#00A859] text-[#00A859]'
                : 'text-gray-600'
            }`}
          >
            <SafeIcon icon={tab.icon} />
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 min-h-[300px]">
        {activeTab === 'blogs' && (
          <ul className="space-y-3">
            {safeData.upcomingBlogs && safeData.upcomingBlogs.map((post, i) => (
              <li key={i} className="flex justify-between items-center border-b border-gray-100 pb-3 last:border-0 last:pb-0">
                <div className="flex items-center gap-3">
                     <div className="bg-blue-50 p-2 rounded text-blue-500">
                        <SafeIcon icon={FiFileText} />
                     </div>
                     <div>
                        <div className="font-medium text-gray-800">{post.title}</div>
                        <div className="text-xs text-gray-500 flex items-center gap-1 mt-0.5">
                             <span className={`px-1.5 py-0.5 rounded ${post.status === 'published' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                                 {post.status || 'Draft'}
                             </span>
                        </div>
                     </div>
                </div>
                <div className="text-sm text-gray-500 flex items-center gap-1">
                    <SafeIcon icon={FiCalendar} className="text-xs" />
                    {post.publishDate}
                </div>
              </li>
            ))}
            {(!safeData.upcomingBlogs || safeData.upcomingBlogs.length === 0) && (
              <p className="text-gray-400 italic text-center py-8">No upcoming blogs scheduled.</p>
            )}
          </ul>
        )}

        {activeTab === 'social' && (
            <ul className="space-y-3">
            {safeData.upcomingSocial && safeData.upcomingSocial.map((post, i) => (
                <li key={i} className="flex justify-between items-center border-b border-gray-100 pb-3 last:border-0 last:pb-0">
                <div className="flex items-center gap-3">
                    <div className="bg-purple-50 p-2 rounded text-purple-500">
                        <SafeIcon icon={FiSmartphone} />
                    </div>
                    <div>
                        <div className="font-medium text-gray-800">{post.content.length > 50 ? post.content.substring(0, 50) + '...' : post.content}</div>
                        <div className="text-xs text-gray-500 mt-0.5 font-semibold text-purple-600">
                                {post.platform}
                        </div>
                    </div>
                </div>
                <div className="text-sm text-gray-500 flex items-center gap-1">
                    <SafeIcon icon={FiCalendar} className="text-xs" />
                    {post.publishDate}
                </div>
                </li>
            ))}
            {(!safeData.upcomingSocial || safeData.upcomingSocial.length === 0) && (
                <p className="text-gray-400 italic text-center py-8">No upcoming social posts scheduled.</p>
            )}
            </ul>
        )}

        {activeTab === 'videos' && (
            <ul className="space-y-3">
            {safeData.upcomingVideos && safeData.upcomingVideos.map((video, i) => (
                <li key={i} className="flex justify-between items-center border-b border-gray-100 pb-3 last:border-0 last:pb-0">
                <div className="flex items-center gap-3">
                    <div className="bg-red-50 p-2 rounded text-red-500">
                        <SafeIcon icon={FiYoutube} />
                    </div>
                    <div>
                        <div className="font-medium text-gray-800">{video.title}</div>
                        <div className="text-xs text-gray-500 mt-0.5 font-semibold text-red-600">
                                {video.platform}
                        </div>
                    </div>
                </div>
                <div className="text-sm text-gray-500 flex items-center gap-1">
                    <SafeIcon icon={FiCalendar} className="text-xs" />
                    {video.publishDate}
                </div>
                </li>
            ))}
             {(!safeData.upcomingVideos || safeData.upcomingVideos.length === 0) && (
                <p className="text-gray-400 italic text-center py-8">No upcoming videos scheduled.</p>
            )}
            </ul>
        )}
      </div>
    </div>
  );
};

export default ContentPlanning;